import React, { useState, useEffect, useContext, createContext } from "react";
import authenticationService from '../services/authentication.service';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AuthenticationProvider
Description : Pagina de AuthenticationProvider para verificar que el usuario este logueado.
Date Autor Modification
================================================================================
2/11/2021 Cristian Andres Pizo Mina - Pagina de AuthenticationProvider.
================================================================================ */
const noop = () => {};

const AuthContext = createContext({ user: null, login: noop, logout: noop });

const AuthenticationProvider = props => {
    
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  // const auth = useMemo({
  //   login: user => setUser(user),
  //   logout: () => setUser(null),
  // }, [user]);


  const login = user => {
    setUser(user);
    setIsAuthenticated(true);
  }

  const logout = () => {
    authenticationService.signOut()
    setUser(null);
    setIsAuthenticated(false)
  }


  useEffect( () => {
    const authUser = authenticationService.getAuthUser();
    
    if(authUser !== null){
      setUser(authUser);
      setIsAuthenticated(true);
    }
    console.log('useEffect: ',  authUser)
  }, [ user ] ) 


  return <AuthContext.Provider value={{ user, login, logout, isAuthenticated }} {...props} />;
}

export default AuthenticationProvider;

export const useAuthentication = () => useContext(AuthContext);